<template>
  <div
    :class="{
      'list-item-container': true
    }"
    style="position: relative;"
  >
    <div v-if="item.type == 'header'" class="caption pt-1 pl-8 grey--text">
      {{ item.text }}
    </div>
    <div
      v-else
      :key="item.id"
      tabindex="0"
      ref="listItem"
      class="list-item"
      @mouseover="!animating ? (hovering = true) : null"
      @mouseleave="hovering = false"
      @click.exact="selectListItem"
      @dragstart.prevent="dragStart"
      draggable="false"
    >
      <!-- <page-list-item-drop-helper v-if="userCanEdit" :item="item"></page-list-item-drop-helper> -->
      <v-row class="indent-helper" no-gutters>
        <v-col
          cols="12"
          ref="item"
          :class="{
            'pl-4': base,
            'dragged-item': dragging && isDraggingSelf,
            'question-list-item': true,
            grey:
              (hovering && !dragging) || highlighted || selected || (dragging && isDraggingSelf),
            'lighten-2': selected,
            'lighten-4': (hovering && !dragging) || highlighted
          }"
        >
          <v-row no-gutters class="align-start">
            <v-btn
              v-if="!base"
              icon
              small
              class="mb-0 ml-4 mr-1 shrink"
              :disabled="!hasChildren"
              @click.stop="toggleChildren"
              @dblclick.stop
            >
              <v-icon
                v-if="hasChildren"
                icon
                small
                :style="!showChildren ? 'transform: rotate(-90deg)' : null"
              >
                keyboard_arrow_down
              </v-icon>
            </v-btn>
            <v-col class="shrink pt-1">
              <!-- <v-icon small class="shrink grey--text text--lighten-1 ">description</v-icon> -->
              <page-type-icon :pageType="item.type" :size="20"></page-type-icon>
            </v-col>
            <v-col class="pl-1">
              <v-row no-gutters>
                <v-col cols="12" style="max-height: 24px;">
                  <div
                    :class="{
                      'text-line': true,
                      'pr-2': true,
                      'pt-1': true,
                      'pl-0': true,
                      'grey--text': true,
                      'purple--text': true,
                      'text--darken-1': !selected,
                      'text--darken-4': selected
                    }"
                    :style="isFocused ? 'font-weight: bold;' : null"
                  >
                    {{ itemText.html }}
                  </div>
                </v-col>
                <v-col
                  cols="12"
                  v-if="item.authorAnswer.answer || item.authorAnswer.confidence"
                  class=""
                >
                  <question-answer
                    :question="item"
                    :disabled="dragging || $vuetify.breakpoint.xsOnly"
                  ></question-answer>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </div>
    <v-list dense v-if="showChildren" class="pt-0 pl-2">
      <page-list-item
        v-for="page in childPages"
        :key="page.id"
        :ref="page.id"
        class=""
        :item="page"
      ></page-list-item>
      <!-- <v-list-item
        v-for="child in children"
        :key="child.id"
        class="pl-6 ml-6"
        @click="setSelectedPageId({ page: item.id, card: child.id })"
        style="font-size: 0.9em"
      >
        <note-state-icon size="small" :state="child.state" class="mr-4"></note-state-icon>
        {{ child.title || 'Untitled Card' }}
      </v-list-item> -->
    </v-list>
  </div>
</template>

<script>
import PageListItemDropHelper from './PageListItemDropHelper';

import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';

import PageTypeIcon from '@/components/ContextDoc/PageTypeIcon';

export default {
  name: 'PageListItem',
  props: ['item', 'base'],
  components: { PageListItemDropHelper, PageTypeIcon },
  data() {
    return {
      hovering: false,
      showChildren: this.base ? true : false,
      isDraggingSelf: false
    };
  },
  mounted() {},
  computed: {
    ...mapGetters('context', ['context', 'userCanEdit']),
    ...mapGetters('auth', ['userId']),
    ...mapGetters('components/dragdrop', ['dragging']),
    ...mapState('pages', ['pages']),
    ...mapState('views/context', [
      'animating',
      'selectedPageId',
      'highlightedItems',
      'focusedContainer',
      'openNotes'
    ]),
    itemText: {
      set(v) {
        console.log('set item text', v);
        if (!this.userCanEdit) {
          return;
        }
        //this.updateQuestionText({ id: this.item.id, text: v });
      },
      get() {
        return { html: this.item.title };
      }
    },
    childPages() {
      console.log('calc child pages');
      if (this.item.type == 'header') return [];
      const childrenNotes = Object.values(this.item.pageNotes)
        .filter(
          p =>
            !p.toDelete &&
            (p.type == 'card' || (p.type == 'note' && p.content.html.slice(1, 3) == 'h1'))
        )
        .sort((a, b) => (a.order > b.order ? 1 : -1));
      return childrenNotes
        .map(n => {
          if (n.type == 'card') {
            return { ...this.pages[n.pageId], noteId: n.id };
          } else {
            const text = n.content.html.slice(4, n.content.html.length - 5);
            return { type: 'header', text };
          }
        })
        .filter(c => c != undefined);
    },
    selected: {
      get() {
        //  returns true if page is selected
        return this.selectedPageId ? this.selectedPageId == this.item.id : this.base;
      },
      set(v) {
        this.setHighlightedItems();
        // this.setSelectedPageId({ page: v });
        this.setFocusedContainer(this.item.noteId);
      }
    },
    highlighted() {
      return this.highlightedItems.includes(this.item.id);
    },
    hasChildren() {
      return this.childPages.length > 0;
    },
    // children() {
    //   return this.cardsByPage[this.item.id];
    //   //return Object.values(this.item.noteCards).filter(n => !n.toDelete);
    // },
    isFocused() {
      console.log('calculate focused');
      return this.item.noteId == this.focusedContainer;
    },
    openNoteStatus() {
      return this.openNotes[this.item.noteId];
    }
  },
  watch: {
    dragging: function(n) {
      //  if we are going from false to true focus
      if (!n) this.isDraggingSelf = false;
    },
    openNoteStatus: function(n) {
      if (n != this.showChildren) {
        setTimeout(() => {
          this.showChildren = n;
        }, 1);
      }
    }
  },
  methods: {
    ...mapActions('context', [
      'addQuestion',
      'removeQuestion',
      'updateQuestionText',
      'updateQuestionType',
      'moveQuestionsByOrder',
      'updateQuestionAuthorAnswer'
    ]),
    ...mapMutations('views/context', [
      'setHoveringItem',
      'setSelectedPageId',
      'addItemToHighlightedItems',
      'removeItemFromHighlightedItems',
      'setHighlightedItems',
      'setShowQuestionList',
      'setOpenNotes',
      'setFocusedContainer'
    ]),
    ...mapMutations('components/dragdrop', ['setDragPosition', 'updateDraggedData']),
    selectQuestionItemByOrder(v) {
      console.log('select question');
      if (v < 0 && this.item.order == 0) {
        //  we want to go to the context title
        this.selected = this.context.id;
      } else {
        const index = this.item.order + v;
        const next = this.questions[index];
        if (next) {
          this.selected = next.id;
        }
      }
    },
    getInnerText(origHtml) {
      const template = document.createElement('template');
      const html = origHtml.trim(); // Never return a text node of whitespace as the result
      template.innerHTML = html;
      return template.content.firstChild ? template.content.firstChild.innerText : origHtml;
    },
    toggleChildren() {
      if (this.showChildren) {
        this.showChildren = false;
        if (this.item.noteId) {
          this.setOpenNotes({ noteId: this.item.noteId, val: false });
        }
      } else {
        this.showChildren = true;
        if (this.item.noteId) {
          this.setOpenNotes({ noteId: this.item.noteId, val: true });
        }
      }
    },
    selectListItem() {
      if (!this.showChildren) {
        this.toggleChildren();
      }
      console.log('seelct list item');
      this.selected = this.item.id;
      this.setShowQuestionList(false);
    },
    tryDeleteItem() {
      if (!this.userCanEdit) {
        return;
      }

      return false;
      //  turning this off for now so don't accidentally delete whole pages
      //  TODO: Check if we should do this
      // console.log('delete');
      // if (this.questions[this.item.order + 1]) {
      //   this.selectQuestionItemByOrder(1);
      // } else {
      //   this.selectQuestionItemByOrder(-1);
      // }
      // this.removeQuestion({ id: this.item.id });
    },
    dragStart(event) {
      const ids = [this.item.id];
      const element = this.$el;
      this.draggingSelf = true;
      const shift = {
        x: event.clientX - element.getBoundingClientRect().left,
        y: event.clientY - element.getBoundingClientRect().top
      };
      // get the element and shift positions for dragHelper
      let html = element.innerHTML;

      // update drag data
      const dragObject = {
        element,
        shift,
        html,
        ids,
        items: [this.item],
        types: ['page'],
        parent: {
          id: this.item.section,
          type: 'section'
        }
      };
      console.log(dragObject);
      //  first set initial drag position
      const { x, y } = event;
      this.setDragPosition({ x, y });
      //  now set drag content
      this.updateDraggedData(dragObject);
      this.draggingSelf = true;
    },
    highlightQuestions() {
      if (!this.userCanEdit) {
        return;
      }
      const item = this.item;
      const startItem = this.questions.find(i => i.id == this.selectedPageId);
      if (!startItem) {
        return;
      }
      let items;
      if (startItem.order < item.order) {
        items = this.questions.slice(startItem.order + 1, item.order + 1);
        items = items.sort((a, b) => {
          return a.order + b.order;
        });
      } else {
        items = this.questions.slice(item.order, startItem.order);
      }
      items = items.map(i => i.id);
      this.setHighlightedItems(items);
    },
    advanceHighlightQuestion(pos) {
      if (!this.userCanEdit) {
        return;
      }
      const item = this.item;
      const highlighted = this.highlightedItems;
      const hLength = highlighted.length;
      let next;

      if (!hLength) {
        //  none selected yet, select next
        next = this.questions[item.order + pos];
        if (next) {
          this.addItemToHighlightedItems(next.id);
        }
      } else {
        //  Check if we are going in the right direction
        const lastItem = this.questions.find(q => q.id == highlighted[hLength - 1]);
        if ((pos > 0 && item.order < lastItem.order) || (pos < 0 && item.order > lastItem.order)) {
          next = this.questions[lastItem.order + pos];
          if (next) {
            this.addItemToHighlightedItems(next.id);
          }
        } else {
          //  remove the last item
          this.removeItemFromHighlightedItems(highlighted[hLength - 1]);
        }
      }
    }
  }
};
</script>

<style>
.text-line {
  display: inline-block;
  font-size: 16px;
  min-width: 100px;
  min-height: 10px;
}

.drag-icon {
  position: absolute;
  top: 5px;
}

.question-list-item {
  position: relative;
  width: 100%;
  transition: 0.1s ease background-color;
  cursor: pointer;
  border-radius: 2px 0 0 2px;
  min-height: 34px;
  padding-top: 2px !important;
}

.dragged-item {
  opacity: 0.3;
}

.indent-helper {
  transition: 0.2s ease-out padding-left;
}

.question-list-item.hover,
.home:hover {
  background: #e1e1e1;
}

.child-item {
  border-left: 4px solid #eee;
}

.section-title {
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  font-size: 0.875rem;
  font-weight: 400;
  padding: 0 0px 0 0px;
}

.text-line,
.section-title p {
  margin-bottom: 0px;
  margin-bottom: 0px;
  white-space: nowrap;
  text-overflow: ellipsis;
  width: 200px;
  overflow: hidden;
}

.context-title p {
  margin-bottom: 0px;
}

.section-title p {
  /* text-transform: uppercase; */
  font-size: 18px;
}
</style>
